import React from "react";
import { UserForm } from "../sub-components/form/user-form.component";
import { useReadOneUserQuery } from "api/endpoints";
import { useParams } from "react-router-dom";

export const UserEditPage = () => {
  const { userId = "" } = useParams();
  const { data: user } = useReadOneUserQuery({ params: { userId } });

  return (user && <UserForm initValues={user} />) || <></>;
};
